import '../src/firebase.js'